"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const toggle_knapp_pure_1 = __importDefault(require("./toggle-knapp-pure"));
class ToggleKnapp extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = (e) => {
            const state = !this.state.pressed;
            this.setState({
                pressed: state,
            });
            if (this.props.onClick)
                this.props.onClick(e, state);
        };
        this.state = {
            pressed: props.pressed,
        };
    }
    render() {
        const renderProps = (0, nav_frontend_js_utils_1.omit)(this.props, "children", "pressed");
        return (React.createElement(toggle_knapp_pure_1.default, Object.assign({ pressed: this.state.pressed }, renderProps, { onClick: this.handleClick }), this.props.children));
    }
}
ToggleKnapp.defaultProps = {
    pressed: false,
};
ToggleKnapp.propTypes = {
    /**
     * Pressed state
     */
    pressed: PT.bool,
    /**
     * Kompakt versjon
     */
    kompakt: PT.bool,
    /**
     * onClick callback som returnerer pressed state
     */
    onChange: PT.func,
};
exports.default = ToggleKnapp;
